import * as React  from "react";
import {cs}        from "@Common/react/chain-services";

export const sothebys_brochure_mls_mailable = ({session, specificationFields, specFieldOnChange, next}) => cs(
    ["specFieldDuplicates", ({}, next) => next([])],
    ["ordinalPosition", ({}, next) => next(2)],
    ["precedingTextBlocks", ({}, next) => next({
        "field_64":
            "Uncheck(Toggle off) each field you wish to remove from the template.",
    })],
    ["ordinalSortingFields", ({}, next) => next([
          "field_64", "field_68", "field_69", "field_66", "field_60",
          "field_63", "field_70", "field_54", "field_73", "field_72",
          "field_36", "field_38", "field_71", "field_8", "field_77",
          "field_15", "field_75", "field_14", "field_10", "field_12",
          "field_16", "field_55", "field_13", "field_9", "field_78",
          "field_17", "field_76", "field_52", "field_74", "field_34",
          "field_18", "field_51", "field_31", "field_79", "field_19",
          "field_80", "field_81", "field_82", "field_83", "field_84",
          "field_56",
        ]),
    ],
    ({ specFieldDuplicates, ordinalPosition, precedingTextBlocks, ordinalSortingFields }, next ) => {
      // Sorting specificationFields based on ordinalSortingFields order
      const sortedSpecificationFields = [...specificationFields].sort(
        (a, b) => ordinalSortingFields.indexOf(a.fieldKey) - ordinalSortingFields.indexOf(b.fieldKey)
      );
      sortedSpecificationFields.forEach((field) => {
        if (precedingTextBlocks[field.fieldKey]) {
          const newTextBlockField = {
            ...field,
            ordinal: ordinalPosition,
            idPrimary: null,
            fieldKey: field.fieldKey + "-textBlock",
            data: precedingTextBlocks[field.fieldKey],
            idDisplayStyle: 20,
            visible: true,
            ignoreSave: true,
          };
          specFieldDuplicates.push(newTextBlockField);
          ordinalPosition++;
        }

        field.ordinal = ordinalPosition;
        specFieldDuplicates.push(field);
        ordinalPosition++;
      });

      next(specFieldDuplicates);
    },
    ({ specFieldDuplicates }, next) => next(specFieldOnChange(specFieldDuplicates)),
    ({ specFieldDuplicates }) => next(specFieldDuplicates)
  );


